import { ValidationResult, ValidationRules } from '../interfaces';

export const validateLength = async (
  value: any,
  props?: ValidationRules
): Promise<ValidationResult> => {
  if (props?.minLength && value?.length && value?.length < props?.minLength) {
    return { valid: false, errors: ['Too short'] };
  }

  if (props?.maxLength && value?.length && value?.length > props?.maxLength) {
    return { valid: false, errors: ['Too long'] };
  }

  return { valid: true, errors: [] };
};
